import React from "react";
import { useListInfoSessions } from "@workspace/api-client-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export function InfoSessionsList() {
  const { data: sessionsPage, isLoading, error } = useListInfoSessions();
  const sessions = sessionsPage?.items ?? [];

  if (isLoading) return <div className="p-6 animate-pulse"><div className="h-8 bg-gray-200 w-1/4 rounded mb-6"></div><div className="h-64 bg-gray-200 rounded"></div></div>;
  if (error) return <div className="p-6 text-red-500">Failed to load info sessions.</div>;

  return (
    <Card className="border-0 shadow-sm">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg text-[#0B132B]">Info Sessions</CardTitle>
        <Button className="bg-[#E6007E] hover:bg-[#c4006b] text-white"><Plus className="w-4 h-4 mr-2"/> Schedule Session</Button>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader className="bg-gray-50">
            <TableRow>
              <TableHead>Title</TableHead>
              <TableHead>Date & Time</TableHead>
              <TableHead>Location</TableHead>
              <TableHead className="text-right">Attendees</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sessions.map((session) => (
              <TableRow key={session.id}>
                <TableCell className="font-medium">{session.title}</TableCell>
                <TableCell>{new Date(session.scheduledAt).toLocaleString()}</TableCell>
                <TableCell>{session.location || 'Online'}</TableCell>
                <TableCell className="text-right">{session.attendedCount || 0} / {session.capacity || '∞'}</TableCell>
                <TableCell><StatusBadge status={session.status} /></TableCell>
              </TableRow>
            ))}
            {sessions.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} className="text-center p-8 text-gray-500">No info sessions found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
